/**
 * Laufzeit-Konstanten ohne TypeBox-Abhängigkeit — damit Browser-Bundles
 * (Join-App, Capture-Lib) den Schema-Code nicht mitschleppen.
 */
export const PROTOCOL_VERSION = 2 as const;

export const DEFAULT_AUDIO = {
  sampleRate: 16000,
  channels: 1,
  encoding: 'pcm_s16le',
  frameSamples: 1280,
} as const;

export const AUTH_HEADER_NAMES = ['authtoken', 'realm', 'participationid', 'me'] as const;

export const SOURCE_ID_PATTERN = '^src_[0-9A-Za-z_-]{4,64}$';

export const KNOWN_ERROR_CODES = [
  'auth_failed',
  'bad_config',
  'busy',
  'engine_unavailable',
  'revoked',
  'forbidden',
  'not_found',
  'auth_backend_unavailable',
  'inference_unavailable',
  'unsupported_language',
  'internal',
] as const;
